import { global as e, functional as r, universal as g, brand as y } from "./color-tokens.esm.js";
const { littlewoods: l, very: o } = y, a = {
  very: {
    ...o
  },
  littlewoods: {
    ...l
  },
  global: {
    ...e
  },
  universal: {
    ...g
  },
  functional: {
    ...r
  },
  base: {
    black: e.black,
    white: e.white
  },
  greys: {
    grey10: e.grey1000,
    grey9: e.grey900,
    grey8: e.grey800,
    grey7: e.grey700,
    grey6: e.grey600,
    grey5: e.grey500,
    grey4: e.grey400,
    grey3: e.grey300,
    grey2: e.grey200,
    grey1: e.grey100
  }
};
export {
  a as colors
};
